import script from "./loginRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./loginRecord.vue?vue&type=script&setup=true&lang=js"

import "./loginRecord.vue?vue&type=style&index=0&id=fbf95334&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbf95334"]])

export default __exports__